import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AcademicProfile from './pages/AcademicProfile';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AcademicProfile />
  </React.StrictMode>
);
